export const SITUACAO_PEDIDO_APP = 10

// Tipo de Cliente


export interface TipoClienteInterface {
  idTipoCliente: string
  descricao: string
}

export enum TipoClienteType {
  PF = 'PF',
  PJ = 'PJ'
}

export const TipoClienteTypes: Array<TipoClienteInterface> = [
  { idTipoCliente: TipoClienteType.PF, descricao: 'Física' },
  { idTipoCliente: TipoClienteType.PJ, descricao: 'Jurídica' }
]

export const IDS_MEIOS_PAGAMENTO_PERMITIR_ALTERACAO_DATA: Array<number> = [1, 5, 7]
// export const IDS_MEIOS_PAGAMENTO_PERMITIR_ALTERACAO_DATA: Array<number> = []

// Permite incluir mais de uma vez o mesmo tipo de pagamento / meio de pagamento na finalização do pedido
// export const IDS_CONDICOES_PAGAMENTOS_PERMITIR_VARIOS_IGUAIS: Array<number> = [76]
export const IDS_CONDICOES_PAGAMENTOS_PERMITIR_VARIOS_IGUAIS: Array<number> = [76]